import { render, staticRenderFns } from "./watchDataLive.vue?vue&type=template&id=30fb1447&scoped=true"
import script from "./watchDataLive.vue?vue&type=script&lang=js"
export * from "./watchDataLive.vue?vue&type=script&lang=js"
import style0 from "./watchDataLive.vue?vue&type=style&index=0&id=30fb1447&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb1447",
  null
  
)

export default component.exports